<template>
  <el-dialog
    title="新增单位"
    :visible.sync="dialogVisible"
    width="52%"
    :before-close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="80px"
      label-position="top"
    >
      <div class="content">
        <div class="content-head">
          <div class="content-item-left">
            <span class="title">基本信息</span>
          </div>
          <div class="content-item-right">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="单位名称" prop="name">
                  <el-input v-model="form.name" placeholder="请输入单位名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="法定代表人" prop="person">
                  <el-input
                    v-model="form.person"
                    placeholder="请输入法定代表人"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位性质" prop="type">
                  <el-input v-model="form.type" placeholder="请输入单位性质"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="统一社会信用代码" prop="code">
                  <el-input
                    v-model="form.code"
                    placeholder="请输入统一社会信用代码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="成立时间" prop="time">
                  <el-input v-model="form.time" placeholder="请输入成立时间"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否上市">
                  <el-switch
                    v-model="form.delivery"
                    active-color="#13b440"
                    inactive-color="#545454"
                    inactive-text="否"
                    active-text="是"
                  ></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="注册地址" prop="address">
                <el-input v-model="form.address" placeholder="注册地址"></el-input>
              </el-form-item>
            </el-row>
          </div>
        </div>
        <div class="content-bottom">
          <div class="content-item-left">
            <span class="title">联系方式</span>
          </div>
          <div class="content-item-right">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="联系人" prop="contact">
                  <el-input v-model="form.contact" placeholder="请输入联系人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="座机号码" prop="num">
                  <el-input v-model="form.num" placeholder="请输入座机号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号码" prop="number">
                  <el-input v-model="form.number" placeholder="请输入手机号码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="传真">
                  <el-input v-model="form.num1" placeholder="请输入传真"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="邮箱">
                  <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="邮编">
                  <el-input v-model="form.num2" placeholder="请输入邮编"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="办公地址" prop="address1">
                <el-input v-model="form.address1" placeholder="办公地址"></el-input>
              </el-form-item>
            </el-row>
          </div>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="dialogVisible = false"
        class="footer-btn item-btn"
      >
        确 定
      </el-button>
      <el-button @click="dialogVisible = false" class="item-btn">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '曜硕科技(上海)有限公司',
        person: '吴洁立',
        type: '私营企业',
        code: '230181991081407',
        time: '2022-09-06',
        address: '大红门服饰商贸城',
        number: '18335263645',
        contact: '孙子涵',
        delivery: true,
      },
      rules: {
        name: {
          required: true,
        },
        person: {
          required: true,
        },
        type: {
          required: true,
        },
        code: {
          required: true,
        },
        time: {
          required: true,
        },
        address: {
          required: true,
        },
        contact: {
          required: true,
        },
        num: {
          required: true,
        },
        number: {
          required: true,
        },
      },
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    edit(row) {
      this.form = row || {}
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding: 16px 20px 10px;
  background-color: #f4f6fc;
  height: 50px;
  box-sizing: border-box;
}
/deep/ .el-dialog__title {
  font-family: Microsoft YaHei;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #24262b;
}
/deep/ .el-form-item__label {
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 19px;
  letter-spacing: 0px;
  color: #545454;
}
/deep/ .el-form-item {
  margin-bottom: 17px;
}
/deep/ .el-dialog__footer {
  padding-top: 0;
}

/deep/ .el-input {
  input {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 19px;
    letter-spacing: 0px;
  }
  input::-webkit-input-placeholder {
    // 针对 谷歌 内核
    font-family: Microsoft YaHei;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 19px;
    letter-spacing: 0px;
    color: #c4c4c4;
  }
  input:-moz-placeholder {
    // 火狐
    font-family: Microsoft YaHei;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 19px;
    letter-spacing: 0px;
    color: #c4c4c4;
  }
  input:-ms-input-placeholder {
    // 微软ie
    font-family: Microsoft YaHei;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 19px;
    letter-spacing: 0px;
    color: #c4c4c4;
  }
}
.content {
  border: solid 1px #eeeeee;
  display: flex;
  flex-direction: column;
  .content-head {
    flex: 1;
    display: flex;
    border-bottom: solid 1px #e1e2e6;
  }
  .content-bottom {
    flex: 1;
    display: flex;
  }

  .content-item-left {
    width: 47px;
    background-color: #ebecf0;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #545454;
      writing-mode: vertical-rl; // css属性文字竖向排列
    }
  }

  .content-item-right {
    flex: 1;
    padding: 24px 24px 0 24px;
  }
}
.footer-btn {
  background-color: #0147eb;
}
.item-btn {
  width: 96px;
  height: 40px;
  font-family: Microsoft YaHei;
  font-size: 16px;
}
</style>
